// extracted by mini-css-extract-plugin
export default {"confetti":"confetti__NzMwN","explode":"explode__ZjZkO","fade":"fade__ZDIyY"};